export default __webpack_public_path__ + "static/media/mc_settings_icon.edee6240.svg";